import React from "react";
import { NavLink } from "react-router-dom";
import "./HomePageTabs.css";

const TABS = [
  { to: "/banners", label: "Banners" },
  { to: "/dynamic-sections", label: "Sections" },
  { to: "/promo-popups", label: "Popups" },
  { to: "/trust-strip", label: "Trust Strip" },
  { to: "/homepage-arrange", label: "Arrange" },
];

const HomePageTabs = () => (
  <nav className="home-tabs" aria-label="Home page sections">
    {TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end
        className={({ isActive }) =>
          `home-tabs__tab${isActive ? " home-tabs__tab--active" : ""}`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
);

export default HomePageTabs;
